import { GridCellParams, GridRenderCellParams } from '@mui/x-data-grid'
import { stringDateComparator } from 'tools/comparators'
import { Tooltip, TypoGraph } from 'components'
import { formatDate } from 'tools/helper'
import strings from 'strings'
import { Button, Box } from '@mui/material'
import { Visibility, LocationOn } from '@mui/icons-material'

const t = strings.TABLE_DEFAULTS

const claimsVehiclesColumns = [
  {
    field: 'vehicleId',
    headerName: 'Vehicle Id',
    minWidth: 50,
    flex: 0,
    sortable: false,
  },
  {
    field: 'carrierId',
    headerName: 'Carrier ID',
    minWidth: 50,
    flex: 0,
    sortable: false,
  },
  {
    field: 'companyEldAuthenticationId',
    headerName: 'Company Eld Authentication ID',
    minWidth: 120,
    flex: 1,
    sortable: true,
  },
  {
    field: 'carrierName',
    headerName: 'Fleet Name',
    minWidth: 120,
    flex: 1,
    sortable: true,
  },
  {
    field: 'assetId',
    headerName: 'Asset ID',
    minWidth: 120,
    flex: 1,
    sortable: true,
  },
  {
    field: 'vin',
    headerName: 'VIN',
    minWidth: 110,
    flex: 1,
    sortable: true,
  },
  {
    field: 'eld',
    headerName: 'TSP',
    minWidth: 100,
    flex: 0.9,
    sortable: true,
  },
  {
    field: 'driverId',
    headerName: 'Driver ID',
    minWidth: 100,
    flex: 0.9,
    sortable: true,
  },
  {
    field: 'driverName',
    headerName: 'Driver Name',
    minWidth: 110,
    flex: 0.9,
    sortable: true,
  },
  {
    field: 'event',
    headerName: 'Event',
    minWidth: 100,
    flex: 0.9,
    sortable: true,
  },
  {
    field: 'eventTime',
    headerName: 'Event Date (UTC)',
    minWidth: 100,
    flex: 0.9,
    sortComparator: stringDateComparator,
    renderCell: (params: GridRenderCellParams) => (
      <TypoGraph component="span" variant="body2">
        {formatDate(params?.row?.eventTime) ??
          params?.row?.eventTime ??
          t.DASH_VALUE}
      </TypoGraph>
    ),
    sortable: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    minWidth: 120,
    flex: 0.8,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, py: 0.5 }}>
        <Tooltip
          title="Route spans 12 hours before and after event time (±12h)"
          placement="top"
        >
          <Button
            data-testid={`view-route-btn-${params.row.vehicleId}`}
            variant="outlined"
            size="small"
            startIcon={<LocationOn />}
            onClick={(e) => {
              e.stopPropagation()
              params.row.onViewRoute?.(params.row)
            }}
            sx={{
              fontSize: '0.75rem',
              minHeight: '28px',
              borderRadius: '4px',
              width: '120px',
            }}
          >
            View Route
          </Button>
        </Tooltip>
        <Button
          data-testid={`view-details-btn-${params.row.vehicleId}`}
          variant="outlined"
          size="small"
          startIcon={<Visibility />}
          onClick={(e) => {
            e.stopPropagation()
            params.row.onViewDetails?.(params.row)
          }}
          sx={{
            fontSize: '0.75rem',
            minHeight: '28px',
            borderRadius: '4px',
            width: '120px',
          }}
        >
          View Details
        </Button>
      </Box>
    ),
  },
]

export { claimsVehiclesColumns }
